import * as React from "react";

import {cs} from "@Common/react/chain-services";

import {ImageFieldCreator} from "./imageFieldCreator";
import {CustomizationTile} from "./customizationTile";


export const Logos = ({orderId, logoData, domRef, updateImage, onApplyImageFromPhotoDashboard, showGallery, imageGuidelinesModal, allowedGalleryTabs, editable, setUnsavedChanges, logoType, showFormattingImageGuidelines}) => cs(
    ({}) =>
        <CustomizationTile
            domRef={domRef}
            header={logoType.charAt(0).toUpperCase() + logoType.slice(1) + "s"}
            imageGuidelinesModal={imageGuidelinesModal}
            imageType={logoType}
            photoCount={logoData.length}
            xdQaName="Logos"
            showFormattingImageGuidelines={showFormattingImageGuidelines}
        >
            {ImageFieldCreator({
                orderId: orderId,
                data: logoData,
                imageType: logoType,
                updateImage,
                showGallery,
                onApplyImageFromPhotoDashboard,
                editable,
                allowedGalleryTabs,
                setUnsavedChanges,
                xdQaName: "Logo",
            })}
        </CustomizationTile>
);